import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _Translate, _IngramLogoBlackWithR;
import React from 'react';
import { Translate } from '@im/react-localization';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { FooterLinks } from './FooterLinks';
import { IngramSocials } from '@im/ui-lib/IngramSocials';
import { IngramLogoBlackWithRX4C } from '../../icons/IngramLogoBlackWithRX4C';
import { useIsDown } from '../../responsive';
import { CopyRight } from './CopyRight';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function FooterIngram(props) {
  var copyRightLinks = props.copyRightLinks,
    footerColumns = props.footerColumns,
    socialMedias = props.socialMedias;
  var isDownSm = useIsDown('sm');
  return /*#__PURE__*/_jsxs(RootStack, {
    "data-testid": "footer-ingram",
    children: [/*#__PURE__*/_jsxs(Grid, {
      container: true,
      gap: isDownSm ? 2 : 0,
      sx: {
        ml: '8px'
      },
      children: [footerColumns && footerColumns.map(function (column, index) {
        return /*#__PURE__*/_jsxs(Grid, {
          item: true,
          md: index === 0 ? 6 : 3,
          sm: index === 0 ? 6 : 3,
          children: [/*#__PURE__*/_jsx(Typography, {
            component: "div",
            "data-testid": "footer-".concat(column.footerColumn.name),
            noWrap: true,
            sx: {
              fontSize: '18px',
              fontWeight: 600,
              mt: '16px'
            },
            variant: "h6",
            children: column.footerColumn.name
          }), /*#__PURE__*/_jsx(Divider, {
            style: isDownSm ? {
              margin: 'auto'
            } : {
              marginLeft: '0px',
              width: '80%'
            }
          }), /*#__PURE__*/_jsx(FooterLinks, {
            links: column.footerColumn.links
          })]
        }, "footer-".concat(column.footerColumn.name, "}"));
      }), socialMedias && /*#__PURE__*/_jsxs(Grid, {
        item: true,
        md: 3,
        sm: 3,
        children: [/*#__PURE__*/_jsx(Typography, {
          align: isDownSm ? 'center' : 'left',
          component: "div",
          "data-testid": "footer-ShareYourStory",
          noWrap: true,
          sx: {
            fontSize: '18px',
            fontWeight: 600,
            mt: '16px'
          },
          variant: "h6",
          children: _Translate || (_Translate = /*#__PURE__*/_jsx(Translate, {
            text: "Footer.ShareYourStory"
          }))
        }), /*#__PURE__*/_jsx(Divider, {
          style: isDownSm ? {
            margin: 'auto'
          } : {
            marginLeft: '0px',
            width: '100%'
          }
        }), /*#__PURE__*/_jsx(IngramSocials, {
          socialMedias: socialMedias
        })]
      })]
    }), /*#__PURE__*/_jsx(Divider, {
      style: {
        marginLeft: '8px'
      }
    }), /*#__PURE__*/_jsx(Box, {
      style: {
        marginBottom: '10px',
        marginLeft: '8px',
        marginTop: '25px'
      },
      sx: {
        flexGrow: 1
      },
      children: /*#__PURE__*/_jsxs(Grid, {
        container: true,
        children: [/*#__PURE__*/_jsx(Grid, {
          item: true,
          md: 4,
          sm: 4,
          sx: {
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'contain'
          },
          xs: 4,
          children: _IngramLogoBlackWithR || (_IngramLogoBlackWithR = /*#__PURE__*/_jsx(IngramLogoBlackWithRX4C, {}))
        }), copyRightLinks && /*#__PURE__*/_jsx(Grid, {
          item: true,
          justifyContent: {
            md: 'end',
            sm: 'end',
            xs: 'end'
          },
          md: 8,
          sm: 8,
          xs: 8,
          children: /*#__PURE__*/_jsx(CopyRight, {
            copyRightLinks: copyRightLinks
          })
        })]
      })
    })]
  });
}
var RootStack = styled(Stack)(function (_ref) {
  var theme = _ref.theme;
  return _defineProperty({
    background: theme.palette.grey['A100'],
    color: theme.palette.common.black,
    marginLeft: '32px',
    marginRight: '32px',
    padding: theme.spacing(2, 3)
  }, theme.breakpoints.down('sm'), {
    textAlign: 'center'
  });
});